import { appLog } from '~src/utils/log';
import { apiCweb } from './api-cweb';
import { Tag } from './archiveSettings';

interface CreateTagParams {
  projectId: string;
  tagData: Pick<Tag, 'title'> & Partial<Tag>;
}

interface EditTagParams {
  projectId: string;
  id: string;
  action?: string;
  tagData?: Pick<Tag, 'title'> & Partial<Tag>;
}

interface DeleteTagParams {
  projectId: string;
  id: string;
}

export const createTag = async ({ projectId, tagData }: CreateTagParams) => {
  appLog('createTag ->', { projectId, tagData });
  const res = await apiCweb.post<Tag>(`/projects/${projectId}/tags`, {
    ...tagData,
    description: '',
  });
  return res.data;
};

export const editTag = async ({
  projectId,
  tagData,
  id,
  action = 'update',
}: EditTagParams) => {
  appLog('editTag ->', { projectId, tagData });
  const res = await apiCweb.put<Tag>(
    `/projects/${projectId}/tags/${id}?action=${action}`,
    {
      ...tagData,
      description: '',
    }
  );
  return res.data;
};

export const deleteTag = async ({ projectId, id }: DeleteTagParams) => {
  appLog('deleteTag ->', { projectId });
  const res = await apiCweb.delete<Tag>(`/projects/${projectId}/tags/${id}`);
  return res.data;
};
